/*
 * Registers the Attributions surfaces (ADR 0025): the /attributions page, and the in-catalog
 * EntityCard that offers attribution on a discovered/observed entity's own overview tab. Same
 * shape as Notifications, Connect and the rest — `PageBlueprint` + `pluginId: 'app'`, plus an
 * `EntityCardBlueprint` whose `attachTo` places it on the catalog overview without touching any
 * entity-page layout. `oss_apps/backstage` untouched.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const ATTRIBUTIONS_PATH = '/attributions';

/** Must match ATTRIBUTION_SUBJECT_ANNOTATION in services/control-plane/src/attribution.ts. */
const ATTRIBUTION_SUBJECT_ANNOTATION = 'stackschematic.dev/attribution-subject';

const attributionsPage = PageBlueprint.make({
  name: 'stackschematic-attributions',
  params: {
    path: ATTRIBUTIONS_PATH,
    loader: async () => {
      const { AttributionsPage } = await import('./AttributionsPage');
      return <AttributionsPage />;
    },
  },
});

/*
 * Only on entities the projection stamped with a pending subject — the discovered and observed
 * entities that could be attributed. The card itself renders nothing unless that subject is still
 * pending, so this filter narrows where it *could* appear; the card decides where it *does*.
 */
const attributionCard = EntityCardBlueprint.make({
  name: 'stackschematic-attribution',
  params: {
    type: 'info',
    filter: (entity: { metadata?: { annotations?: Record<string, string> } }) =>
      Boolean(entity.metadata?.annotations?.[ATTRIBUTION_SUBJECT_ANNOTATION]),
    loader: async () => {
      const { AttributionCard } = await import('./AttributionCard');
      return <AttributionCard />;
    },
  },
});

export const stackSchematicAttributionsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [attributionsPage, attributionCard],
});
